import { ca } from '@cian/analytics';

export function trackModalOpen() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'hover',
    label: 'unique_content_popup',
    useLastProducts: true,
  });
}
